// Campus photo for /colleges/purdue-university: CC BY 4.0, by Julian Herzog, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AFrederick_L_Hovde_Hall_of_Administration_Purdue_University_2016_01.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/purdue-university/; credited under the photo.
const photo = {
    "slug": "purdue-university",
    "alt": "Hovde Hall of Administration framed by trees and flower beds at Purdue University in West Lafayette, Indiana",
    "src": "/colleges/purdue-university/campus-1600.webp",
    "srcSmall": "/colleges/purdue-university/campus-800.webp",
    "srcMid": "/colleges/purdue-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/purdue-university/og.jpg",
    "title": "Frederick L Hovde Hall of Administration Purdue University 2016 01",
    "author": "Julian Herzog",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AFrederick_L_Hovde_Hall_of_Administration_Purdue_University_2016_01.jpg",
    "read": "2026-10-01"
};

export default photo;
